var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10006_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.15137 13.9707C10.9154 13.9707 13.9668 10.9193 13.9668 7.15527C13.9668 3.39122 10.9154 0.339844 7.15137 0.339844C3.38731 0.339844 0.335938 3.39122 0.335938 7.15527C0.335938 10.9193 3.38731 13.9707 7.15137 13.9707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87717 0.191406C10.5675 0.191406 13.559 3.18145 13.559 6.86979C13.559 10.5581 10.5675 13.5482 6.87717 13.5482C3.18688 13.5482 0.195312 10.5582 0.195312 6.86979C0.195312 3.18142 3.18688 0.191406 6.87717 0.191406Z",
    fill: "url(#paint0_linear_10006_1055)",
    stroke: "#733306",
    strokeWidth: 0.328125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18351 0.666526C3.58234 0.663532 0.665416 3.58043 0.668411 7.1816C0.667954 8.838 1.29911 10.4322 2.43326 11.6395C1.16214 10.4486 0.366809 8.75605 0.365237 6.87836C0.362243 3.27718 3.27914 0.360276 6.88032 0.363284C8.75798 0.364842 10.4506 1.16019 11.6414 2.4313C10.4342 1.29716 8.83992 0.666033 7.18351 0.666526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07471 12.2158C9.91191 12.2158 12.2119 9.91581 12.2119 7.07861C12.2119 4.24141 9.91191 1.94141 7.07471 1.94141C4.23751 1.94141 1.9375 4.24141 1.9375 7.07861C1.9375 9.91581 4.23751 12.2158 7.07471 12.2158Z",
    fill: "#FFFB79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86953 11.8367C9.6193 11.8367 11.8484 9.60758 11.8484 6.85781C11.8484 4.10804 9.6193 1.87891 6.86953 1.87891C4.11975 1.87891 1.89062 4.10804 1.89062 6.85781C1.89062 9.60758 4.11975 11.8367 6.86953 11.8367Z",
    fill: "url(#paint1_linear_10006_1055)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11939 2.20845C4.4283 2.20845 2.24674 4.38928 2.24674 7.07948C2.24674 9.04049 3.40604 10.7307 5.07682 11.503C3.21293 10.7833 1.89062 8.9749 1.89062 6.85733C1.89062 4.10782 4.11967 1.87891 6.86935 1.87891C8.77719 1.87891 10.4343 2.95198 11.2702 4.52744C10.4124 3.13608 8.87434 2.20845 7.11939 2.20845ZM5.07682 11.503L11.2702 4.52744L5.07682 11.503Z",
    fill: "url(#paint2_linear_10006_1055)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3628 6.64513L7.44411 11.0232C7.38225 11.0849 7.29846 11.1195 7.2111 11.1195C7.12373 11.1195 7.03994 11.0849 6.97809 11.0232L3.0594 6.64513C3.02881 6.6146 3.00454 6.57835 2.98798 6.53843C2.97141 6.49852 2.96289 6.45573 2.96289 6.41251C2.96289 6.3693 2.97141 6.32651 2.98798 6.28659C3.00454 6.24668 3.02881 6.21042 3.0594 6.1799L4.70423 4.09174C4.80624 3.95517 4.95968 3.85338 5.1224 3.8969H9.29983C9.47562 3.84987 9.63572 3.97457 9.73088 4.12951L11.3628 6.17995C11.3934 6.21047 11.4176 6.24673 11.4342 6.28664C11.4507 6.32655 11.4593 6.36933 11.4593 6.41254C11.4593 6.45575 11.4507 6.49853 11.4342 6.53844C11.4176 6.57835 11.3934 6.61461 11.3628 6.64513Z",
    fill: "url(#paint3_linear_10006_1055)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9866 6.23249L7.10947 10.5694C7.04831 10.6305 6.96539 10.6648 6.87893 10.6648C6.79247 10.6648 6.70955 10.6305 6.64839 10.5694L2.77128 6.23249C2.741 6.20224 2.71699 6.16632 2.7006 6.12678C2.68422 6.08724 2.67578 6.04486 2.67578 6.00206C2.67578 5.95927 2.68422 5.91689 2.7006 5.87735C2.71699 5.83781 2.741 5.80189 2.77128 5.77164L4.39864 3.70308C4.49957 3.5678 4.65138 3.46697 4.81238 3.51009H8.94552C9.11944 3.46351 9.27785 3.58704 9.37199 3.74052L10.9866 5.77157C11.0169 5.80183 11.0409 5.83775 11.0573 5.8773C11.0737 5.91685 11.0821 5.95923 11.0821 6.00204C11.0821 6.04485 11.0737 6.08723 11.0573 6.12678C11.0409 6.16632 11.0169 6.20224 10.9866 6.23249Z",
    fill: "#FDEC3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9866 6.23237L7.10952 10.5693C7.04836 10.6304 6.96544 10.6647 6.87898 10.6647C6.79252 10.6647 6.7096 10.6304 6.64844 10.5693L6.87726 6.56911L6.88496 3.50996H8.94557C9.11949 3.46338 9.27789 3.58691 9.37204 3.74039L10.9867 5.77144C11.017 5.8017 11.041 5.83762 11.0574 5.87717C11.0738 5.91672 11.0822 5.95911 11.0822 6.00192C11.0822 6.04473 11.0738 6.08711 11.0574 6.12666C11.041 6.1662 11.0169 6.20212 10.9866 6.23237Z",
    fill: "#E99D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2581 6.55469L7.82578 9.77642L7.10937 10.5704C7.04821 10.6315 6.96529 10.6659 6.87883 10.6659C6.79237 10.6659 6.70945 10.6315 6.64829 10.5704L5.92853 9.77642L4.52734 6.55469H9.2581Z",
    fill: "#FECA1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26162 6.55367H4.53087C4.53087 6.55367 2.67465 6.07301 2.6797 5.98355C2.68413 5.90362 2.71795 5.82815 2.77466 5.77164L4.40203 3.70308C4.50295 3.5678 4.65476 3.46697 4.81576 3.51009H8.94891C9.12283 3.46351 9.28123 3.58704 9.37537 3.74052L10.99 5.77157C11.0213 5.80276 11.0459 5.84001 11.0623 5.88104C11.0787 5.92207 11.0866 5.96602 11.0854 6.01019C11.0834 6.09095 9.26162 6.55367 9.26162 6.55367Z",
    fill: "#FECA1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88255 6.55367H4.53087C4.53087 6.55367 2.67465 6.07301 2.6797 5.98355C2.68413 5.90362 2.71795 5.82815 2.77466 5.77164L4.40203 3.70308C4.50295 3.5678 4.65476 3.46697 4.81576 3.51009H6.88817L6.88255 6.55367Z",
    fill: "#FFF9CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2581 6.55506H4.52734L6.88524 3.5L9.2581 6.55506Z",
    fill: "#FDEC3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10006_1055",
    x1: 6.87717,
    y1: 13.5484,
    x2: 6.87717,
    y2: 0.191379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDED3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10006_1055",
    x1: 6.86953,
    y1: 11.8361,
    x2: 6.86953,
    y2: 1.87954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD8901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#F0AA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10006_1055",
    x1: 6.58034,
    y1: 11.5032,
    x2: 6.58034,
    y2: 1.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E99000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D5306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10006_1055",
    x1: 7.21112,
    y1: 11.1195,
    x2: 7.21112,
    y2: 3.88666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C5306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E99000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10006_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconCoin);
export default __webpack_public_path__ + "static/media/tab_icon_coin.b1ab3433ddd7bc1fa5189db7c36b17d1.svg";
export { ForwardRef as ReactComponent };